// STATE
const state = { _setting: {} }

// ACTIONS
const actions = {
  insertSetting({ commit }, paramSetting) {
    commit('setSetting', paramSetting)
  }
}
// MUTATIONS
const mutations = {
  setSetting(state, paramSetting) {
    state['_setting'] = {...paramSetting}
  }
}
// GETTERS
const getters = {
  getSetting() {
    return state['_setting']
  }
}
export const setting = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/setting.module.js